<template>
    <div class="th-footer">
        <WFIcon name="clock"></WFIcon><div class="opening-hours" data-translation-element="opening-hours"></div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="less">
     @import '../css/variables';
     .th-footer {
        flex-basis: 6.4rem;
        flex-shrink: 0;
        background-color: #333333;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-size: 1.8rem;

        & > div {
            padding-top: 0.7rem;
            display: flex;

            b {
                padding-top: 2px;
            }
        }

        .icon-clock {
            height: 2.4rem;
            fill: @primary-color;
            margin-right: 1.2rem;
        }
     }
</style>